import { Typography } from '@mui/material';
import { IconType } from 'react-icons';
import {
  PiFileCsvFill,
  PiFileFill,
  PiFileJpgFill,
  PiFilePdfFill,
  PiFilePngFill,
  PiFileXlsFill,
} from 'react-icons/pi';

import DownloadStatus from './DownloaderStatus';
import { type FileType, type SelectedFile } from './interfaces';
import RetryDownload from './RetryDownload';

type DownloadItemProps = {
  file: SelectedFile;
};

const fileTypeIcons: Record<FileType, IconType> = {
  pdf: PiFilePdfFill,
  csv: PiFileCsvFill,
  xlsx: PiFileXlsFill,
  png: PiFilePngFill,
  jpg: PiFileJpgFill,
};

const DownloadItem: React.FC<DownloadItemProps> = ({ file }) => {
  const { name, status, type } = file;

  const FileIcon = fileTypeIcons[type] || PiFileFill;

  return (
    <li className="download-item">
      <div className="download-item-content">
        <FileIcon size={24} />
        <div className="download-item-name">
          <Typography
            whiteSpace={'nowrap'}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            style={{
              maxWidth: 300,
            }}
          >
            {status === 'error' ? (
              <>
                <strong>Error:</strong> {name}
              </>
            ) : (
              name
            )}
          </Typography>
          {(status === 'downloading' || status === 'error') && <RetryDownload file={file} />}
        </div>
      </div>

      <DownloadStatus status={status} />
    </li>
  );
};

export default DownloadItem;
